export function initKadenceFilterI18n() {
  const translatedPlaceholder = "Seleziona...";
  const selector = ".kadence-query-filter select.kb-filter";

  const applyPlaceholder = (root = document) => {
    const selects = root.querySelectorAll(selector);
    for (const select of selects) {
      const firstOption = select.options && select.options.length ? select.options[0] : null;
      if (!firstOption) continue;

      // Kadence usa tipicamente prima option vuota come placeholder.
      if (firstOption.value === "" && firstOption.textContent !== translatedPlaceholder) {
        firstOption.textContent = translatedPlaceholder;
      }
    }
  };

  const scheduleApply = () => {
    window.setTimeout(() => applyPlaceholder(document), 100);
  };

  applyPlaceholder(document);

  window.addEventListener("kb-query-filter-update", scheduleApply);
  window.addEventListener("kb-query-filter-trigger", scheduleApply);
  window.addEventListener("kb-query-loaded", scheduleApply);

  if (window.MutationObserver) {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!node || node.nodeType !== 1) continue;
          if (node.matches && node.matches(selector)) {
            applyPlaceholder(node.parentElement || document);
            return;
          }
          if (node.querySelector && node.querySelector(selector)) {
            applyPlaceholder(node);
            return;
          }
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
}
